export default __webpack_public_path__ + "static/media/workspace-one.ea323704.svg";